import { useState } from "react"

import Style from "./style"
import checkedIcon from "./asset/checked.svg"
import checkIcon from "./asset/check.svg"

import useGetExamDetail from "entity/tryoutExam/useGetExamDetail"
import usePostExam from "entity/tryoutExam/usePostExam"

import { convertProGradeAsName } from "shared/constant/lookup/proGrade"
import DefaultButton from "shared/ui/DefaultButton"
import { useEffect } from "react"

const TyroutExamTaking = () => {
    const [answerList, setAnswerList] = useState([])

    const [getExamDetail] = useGetExamDetail()
    const [postExamEvent] = usePostExam(answerList)

    // 문제 길이와 동일하게 answer state 초기화
    useEffect(() => {
        const tmpList = []
        getExamDetail?.data?.question?.forEach(elem => tmpList.push(null))
        setAnswerList(tmpList)
    }, [getExamDetail])

    // 선다 선택 이벤트
    const clickChoiceEvent = (questionIndex, choiceIndex) => {
        const tmpList = [...answerList]
        tmpList[questionIndex] = choiceIndex
        setAnswerList(tmpList)
    }

    return (
        <Style.Wrapper>

            <Style.TitleDiv>
                <h2>{convertProGradeAsName[getExamDetail?.data?.pro_grade_flag]} 프로 필기 시험</h2>
                <Style.InfoDiv>
                    <h2>프로 자격</h2>
                    <p>{convertProGradeAsName[getExamDetail?.data?.pro_grade_flag]}</p>
                </Style.InfoDiv>
                <Style.InfoDiv>
                    <h2>전체 문제 개수</h2>
                    <p>{getExamDetail?.data?.question?.length}개</p>
                </Style.InfoDiv>
                <Style.InfoDiv>
                    <h2>커트라인 점수</h2>
                    <p>{getExamDetail?.data?.cutoff}점</p>
                </Style.InfoDiv>
            </Style.TitleDiv>

            <Style.ContentDiv>
                {getExamDetail?.data?.question?.map((elem, index) =>
                    <Style.QuestionDiv>
                        <p>Q{index + 1}. ({elem?.point}점) {elem?.problem}</p>
                        {elem?.choice?.map((choiceElem, choiceIndex) =>
                            <Style.ChoiceBtn
                                $checked={answerList[index] === choiceIndex}
                                onClick={() => clickChoiceEvent(index, choiceIndex)}>
                                <img src={answerList[index] === choiceIndex ? checkedIcon : checkIcon} />
                                {choiceIndex + 1}. {choiceElem}
                            </Style.ChoiceBtn>
                        )}
                    </Style.QuestionDiv>
                )}
            </Style.ContentDiv>

            <DefaultButton clickEvent={postExamEvent}>제출하기</DefaultButton>

        </Style.Wrapper>
    )
}

export default TyroutExamTaking